import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PriceCheckIcon(props: IconProps) {
    return <Icon {...props} iconKey={"price_check"}/>
}
